import _ from 'lodash';
import StatusBreakout from '../../charts/status-breakout/StatusBreakout';
import usePanelDataService from '../../../services/PanelDataService';

const countsUrl = {
    url: '/query/chart',
    params: {
        type: 'businessService',
        metrics: ['aggStatusCounts'],
    },
};

export default function BusinessServicesOverviewStatusBreakout({
    onTimeRangeChange = _.noop,
    disableSelection = false,
    noSelection = false,
}) {
    const counts = usePanelDataService(countsUrl);

    if (!counts) return null;

    return (
        <StatusBreakout
            opacity={0.8}
            height={80}
            data={counts?.data?.[0] || {}}
            metricName={counts?.legend?.[0] || ''}
            onTimeRangeChange={onTimeRangeChange}
            disableSelection={disableSelection}
            noSelection={noSelection}
        />
    );
}
